<template>
    <div class="invitados_no_confirmados2">
        <v-container class="my-4">

            <v-layout row align-center class="mb-4">
                <v-flex>
                    <div class="display-title">
                        <v-icon large color="primary" class="mr-2">how_to_reg</v-icon>
                        <span class="headline font-weight-bold primary--text">Validacion de Datos</span>
                    </div>
                    <p class="subheading grey--text mt-1 mb-0">Gestiona y valida los usuarios pendientes de confirmacion</p>
                </v-flex>
            </v-layout>

            <v-dialog v-model="dialog" max-width="900px">
                <v-card>
                    <v-toolbar flat color="primary" dark>
                        <v-toolbar-title>
                            <v-icon class="mr-2">insert_drive_file</v-icon>
                            Visualizador de Archivo
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="downloadFile" :disabled="!fileUrl">
                            <v-icon>cloud_download</v-icon>
                        </v-btn>
                        <v-btn icon @click="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-0">
                        <div v-if="isPdf" style="height: 80vh;">
                            <iframe :src="fileUrl" width="100%" height="100%" frameborder="0"></iframe>
                        </div>
                        <div v-else class="text-xs-center pa-4">
                            <img :src="fileUrl" alt="Imagen" style="max-width: 100%; max-height: 80vh; border-radius: 8px;" />
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogInfoGuest" scrollable max-width="1000px">
                <v-card class="elevation-4">
                    <v-toolbar dark color="primary">
                        <v-icon class="mr-2">mdi-home-edit</v-icon>
                        <v-toolbar-title>Validar Datos</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="dialogInfoGuest = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="userInfo !== null" class="pa-4">
                        <v-window v-model="step">
                            <v-window-item :value="1">
                                <v-subheader class="pl-0 font-weight-bold">
                                    <v-icon small class="mr-1" color="primary">person</v-icon>
                                    Informacion Personal
                                </v-subheader>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field class="pl-3 pr-3" prepend-icon="mdi-account"
                                            :label="$t('Nombre')" :value="userInfo.first_name" readonly outlined dense>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field class="pl-3 pr-3" prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')" :value="userInfo.last_name" readonly outlined dense>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field class="pl-3 pr-3" prepend-icon="mdi-email"
                                            label="E-Mail" :value="userInfo.email" readonly outlined dense>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field class="pl-3 pr-3" prepend-icon="mdi-cellphone"
                                            :label="$t('celular')" :value="userInfo.celular" readonly outlined dense>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <template v-if="documentacion.length > 0">
                                    <v-divider class="my-3"></v-divider>
                                    <v-subheader class="pl-0 font-weight-bold">
                                        <v-icon small class="mr-1" color="primary">attach_file</v-icon>
                                        Documentos Adjuntos
                                    </v-subheader>
                                    <v-layout wrap>
                                        <template v-for="(doc, docKey) in documentacion">
                                            <v-flex xs12 sm6 :key="`preview-${docKey}`" class="mb-3 pa-1">
                                                <v-card outlined class="pa-3" style="height: 100%;">
                                                    <div class="font-weight-bold body-2 mb-2 primary--text">{{ doc.idDocumentation.name }}</div>
                                                    <div class="mb-2" v-if="isOcrSupported(doc)">
                                                        <v-chip small :color="doc.is_valid ? 'success' : 'error'" text-color="white" class="mr-1 mb-1">
                                                            <v-icon left small>{{ doc.is_valid ? 'check_circle' : 'error' }}</v-icon>
                                                            {{ doc.is_valid ? 'Valido' : 'Invalido' }}
                                                        </v-chip>
                                                        <v-chip v-if="doc.is_current !== null" small :color="doc.is_current ? 'success' : 'warning'" text-color="white" class="mb-1">
                                                            <v-icon left small>event</v-icon>
                                                            {{ doc.is_current ? 'Vigente' : 'Vencido' }}
                                                        </v-chip>
                                                        <v-chip v-else small color="grey" text-color="white" class="mb-1">
                                                            <v-icon left small>help</v-icon>
                                                            Vigencia N/A
                                                        </v-chip>
                                                    </div>
                                                    <div class="caption grey--text text--darken-2 mb-2 text-xs-left">
                                                        <div v-if="doc.valid_until"><strong>Vence:</strong> {{ formatDate(doc.valid_until) }}</div>
                                                        <div v-if="doc.ocr_confidence"><strong>Confianza:</strong> {{ doc.ocr_confidence }}%</div>
                                                    </div>
                                                    <v-expansion-panel v-if="hasExtractedData(doc.extracted_data)" class="elevation-0 mb-2">
                                                        <v-expansion-panel-content class="grey lighten-4">
                                                            <template v-slot:header>
                                                                <div class="caption font-weight-bold">Datos Extraidos</div>
                                                            </template>
                                                            <v-card flat color="transparent">
                                                                <v-card-text class="pa-2 caption text-xs-left">
                                                                    <div v-for="(value, fKey) in parseExtractedData(doc.extracted_data)" :key="fKey" class="mb-1">
                                                                        <strong>{{ formatKey(fKey) }}:</strong> {{ formatValue(value) }}
                                                                    </div>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                    <v-btn block small outline color="primary" class="mt-2"
                                                        @click="openDialog(doc.file)" :disabled="!doc.file">
                                                        <v-icon left small>visibility</v-icon>
                                                        Ver Documento
                                                    </v-btn>
                                                </v-card>
                                            </v-flex>
                                        </template>
                                    </v-layout>
                                </template>
                                <v-divider class="my-3"></v-divider>
                                <v-subheader class="pl-0 font-weight-bold">
                                    <v-icon small class="mr-1" color="primary">verified_user</v-icon>
                                    Los datos de la persona son correctos?
                                </v-subheader>
                                <v-radio-group row v-model="confirm" name="confirm" :mandatory="false" class="mt-0">
                                    <v-radio class="pl-3 pr-3" :label="$t('Si')" value="true" outlined></v-radio>
                                    <v-radio class="pl-3 pr-3" label="No" value="false" outlined></v-radio>
                                </v-radio-group>
                            </v-window-item>
                        </v-window>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end pa-3">
                        <v-btn flat @click="dialogInfoGuest = false">Cancelar</v-btn>
                        <v-btn color="primary" depressed :loading="loading"
                            @click="activateDeleteGuest(userInfo.temporalToken)">
                            <v-icon left>send</v-icon>
                            {{ $t('enviar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogConfirm" max-width="380">
                <v-card class="justify-center">
                    <v-card-title class="warning display-1 text--primary justify-center" primary-title>
                        {{ $t('confirmar_identidad') }}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        Selecciona <b>Si</b> o <b>No</b>, para confirmar la Identidad.
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialogConfirm = false">{{ $t('aceptar') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog_seguro" persistent width="300">
                <v-card class="justify-center">
                    <v-card-title class="warning display-1 text--primary justify-center" primary-title>
                        {{ $t('aviso') }}
                    </v-card-title>
                    <v-card-text class="text-xs-center">
                        <h4>{{ $t('pgt_seguro') }}</h4><br>
                        <h5>{{ $t('msg_guest_corrections') }}</h5>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="dialog_seguro = false">No</v-btn>
                        <v-spacer />
                        <v-btn color="primary" @click="eliminar_invitado()">{{ $t('Si') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogResendEmail" persistent max-width="440">
                <v-card>
                    <v-card-title class="headline primary white--text pa-4">
                        <v-icon dark class="mr-2">email</v-icon>
                        Reenviar Correo de Pre-Registro
                    </v-card-title>
                    <v-card-text class="pa-4">
                        <v-alert type="info" :value="true" outline class="mb-3">
                            El reenvio de correo de pre registro puede enviarse una vez cada 24 hrs.
                        </v-alert>
                        <p class="body-1 mb-0" v-if="resendTargetUser">
                            Deseas reenviar el correo a
                            <strong>{{ resendTargetUser.first_name }} {{ resendTargetUser.last_name }}</strong>
                            (<span class="grey--text">{{ resendTargetUser.email }}</span>)?
                        </p>
                    </v-card-text>
                    <v-card-actions class="pa-3">
                        <v-spacer></v-spacer>
                        <v-btn flat @click="dialogResendEmail = false" :disabled="loadingResend">Cancelar</v-btn>
                        <v-btn color="primary" depressed :loading="loadingResend" @click="resendPreregistrationEmail">
                            <v-icon left>send</v-icon>
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-card class="elevation-2">
                <v-card-title class="pa-4">
                    <v-icon color="primary" class="mr-2">people</v-icon>
                    <span class="title">{{ $t('invitados_no_confirmados') }}</span>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        :label="$t('Buscar')"
                        single-line
                        hide-details
                        solo
                        dense
                        style="max-width: 280px;"
                    ></v-text-field>
                </v-card-title>
                <v-divider></v-divider>
                <v-data-table
                    :headers="headers"
                    :loading="loading_data_invitados_no_confirmados"
                    :items="invitados_no_confirmados"
                    :search="search"
                    :rows-per-page-text="$t('filas_por_pagina')"
                    :rows-per-page-items="[
                        {text: '5', value: 5},
                        {text: '10', value: 10},
                        {text: '25', value: 25},
                        {text: this.$t('todos'), value: -1}
                    ]"
                    class="elevation-0"
                >
                    <template v-slot:items="props">
                        <td class="text-xs-center" style="width: 80px;">
                            <v-tooltip bottom v-if="props.item.roll === 15 || props.item.roll === 11">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon small v-on="on" @click="openResendDialog(props.item)">
                                        <v-icon color="blue darken-1">forward_to_inbox</v-icon>
                                    </v-btn>
                                </template>
                                <span>Reenviar correo de pre-registro</span>
                            </v-tooltip>
                            <v-tooltip bottom v-else>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon small disabled v-on="on">
                                        <v-icon color="grey lighten-1">forward_to_inbox</v-icon>
                                    </v-btn>
                                </template>
                                <span>No aplica para este rol</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-center" style="width: 130px;">
                            <v-btn v-if="props.item.ine_frente !== null"
                                small depressed color="primary"
                                @click="userInfo = props.item; getDocumentationByUser(props.item, props.item.documentationByInvitation || []); dialogInfoGuest = true; confirm = null">
                                <v-icon left small>how_to_reg</v-icon>
                                {{ $t('validar') }}
                            </v-btn>
                            <template v-else>
                                <v-btn v-show="props.item.roll === 0" small disabled depressed
                                    @click="userInfo = props.item; dialogInfoGuest = true">
                                    {{ $t('validar') }}
                                </v-btn>
                                <v-chip v-show="props.item.roll === 15" small color="warning" text-color="white">
                                    <v-icon left small>warning</v-icon>
                                    Sin registrar
                                </v-chip>
                            </template>
                        </td>
                        <td>
                            <div class="font-weight-medium">{{ props.item.first_name === '' ? 'Sin Registrar' : props.item.first_name }}</div>
                        </td>
                        <td>{{ props.item.last_name === '' ? 'Sin registrar' : props.item.last_name }}</td>
                        <td>
                            <v-chip small outline color="blue darken-1" v-if="props.item.celular">
                                <v-icon left small>phone</v-icon>
                                {{ props.item.celular }}
                            </v-chip>
                            <span v-else class="grey--text">-</span>
                        </td>
                        <td>
                            <span v-if="props.item.email">{{ props.item.email }}</span>
                            <span v-else class="grey--text">Sin Registrar</span>
                        </td>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            {{ $t('ningun_resultado_1') }} "{{ search }}" {{ $t('ningun_resultado_2') }}
                        </v-alert>
                    </template>
                    <template v-slot:pageText="props">
                        {{ props.rowsPerPage }}
                        {{ $t('Empleados') }} {{ props.pageStart }} - {{ props.pageStop }} {{ $t('prep_de') }} {{ props.itemsLength }}
                    </template>
                </v-data-table>
            </v-card>

        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)

    export default {
        name: "invitados_no_confirmados2",
        created: function(){
            this.get_invitados_no_confirmados()
        },
        data: () => ({
            search: '',
            invitados_no_confirmados: [],
            headers: [],
            userInfo: [],
            confirm: null,
            dialogConfirm: false,
            loading: false,
            step: 1,
            dialogInfoGuest: false,
            dialog_seguro: false,
            dialog: false,
            documentacion: [],
            isPdf: false,
            fileUrl: '',
            loading_data_invitados_no_confirmados: false,
            dialogResendEmail: false,
            resendTargetUser: null,
            loadingResend: false,
            labels: {
                ine_frente: 'INE Frente',
                ine_reverso: 'INE Reverso',
                foto_cara: 'Foto de Cara',
                dc3: 'DC3',
                imss: 'IMSS',
                curp: 'CURP',
                rfc: 'RFC',
                licencia: 'Licencia de Conducir',
            },
            currentFile: null,
            currentPreview: null,
            currentLabel: '',
            files: {},
            ineFront: {
                id: 1000,
                idDocumentation: { id: 1000, name: 'INE Frente' },
                file: null,
                idUser: null
            },
            ineBack: {
                id: 1001,
                idDocumentation: { id: 1001, name: 'INE Reverso' },
                file: null,
                idUser: null
            },
        }),
        beforeUpdate () {
            this.headers = [
                {
                    text: 'Accion',
                    align: 'center',
                    sortable: false,
                    value: 'resend'
                },
                {
                    text: this.$t('validar'),
                    align: 'center',
                    sortable: false,
                    value: 'avatar'
                },
                {
                    text: this.$t('Nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('Apellido'),
                    align: 'left',
                    sortable: true,
                    value: 'apellido'
                },
                {
                    text: this.$t('celular'),
                    align: 'left',
                    sortable: true,
                    value: 'celular'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'email'
                },
            ]
        },
        methods: {
            openDialog (fileUrl) {
                this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
                this.fileUrl = fileUrl
                this.dialog = true
            },
            downloadFile () {
                const link = document.createElement('a')
                link.href = this.fileUrl
                link.download = ''
                link.target = '_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            },
            get_invitados_no_confirmados () {
                this.loading_data_invitados_no_confirmados = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/GetUsers/NoActivated',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        this.invitados_no_confirmados = response.status === 204 ? [] : response.data
                        this.loading_data_invitados_no_confirmados = false
                    })
                    .catch(error => {
                        this.loading_data_invitados_no_confirmados = false
                        console.log(error)
                    })
            },
            getDocumentationByUser (user, documentationByInvitation = []) {
                this.documentacion = []
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get-documents-by-user/' + user.id + '/',
                    headers: { 'Content-Type': 'application/json' }
                }
                axios(config)
                    .then(response => {
                        this.documentacion = this.processDocumentation(response.data, documentationByInvitation)
                        this.ineFront.file = user.ine_frente
                        this.ineBack.file = user.ine_atras
                        this.documentacion.push(this.ineFront)
                        this.documentacion.push(this.ineBack)
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            processDocumentation(documentationsByUser, documentationsByInvitation) {
                let processedDocumentations = []
                const safeDocsByUser = Array.isArray(documentationsByUser) ? documentationsByUser : []
                let validInvDocs = []
                if (Array.isArray(documentationsByInvitation)) {
                    validInvDocs = documentationsByInvitation.filter(d => {
                        if (!d) return false
                        if (d.idDocumentation && typeof d.idDocumentation === 'object' && d.idDocumentation.id != null) {
                            return true
                        }
                        if ((typeof d.idDocumentation === 'number' || typeof d.idDocumentation === 'string') && d.idDocumentation) {
                            return true
                        }
                        return false
                    })
                }
                if (validInvDocs.length === 0) {
                    return safeDocsByUser.map(doc => ({
                        id: doc.id,
                        idDocumentation: doc.idDocumentation,
                        name: (doc.idDocumentation && doc.idDocumentation.name) || '',
                        file: doc.file,
                        is_valid: doc.is_valid,
                        is_company_document: (doc.idDocumentation && doc.idDocumentation.is_company_document) || false,
                        uploaded_at: doc.uploaded_at,
                        ocr_confidence: doc.ocr_confidence,
                        extracted_data: doc.extracted_data,
                        valid_until: doc.valid_until
                    }))
                } else {
                    for(let i = 0; i < validInvDocs.length; i++) {
                        let found = false
                        let requiredDocId = null
                        if (validInvDocs[i].idDocumentation && typeof validInvDocs[i].idDocumentation === 'object') {
                            requiredDocId = validInvDocs[i].idDocumentation.id
                        } else if (typeof validInvDocs[i].idDocumentation === 'number' || typeof validInvDocs[i].idDocumentation === 'string') {
                            requiredDocId = validInvDocs[i].idDocumentation
                        }
                        for(let j = 0; j < safeDocsByUser.length; j++) {
                            if(safeDocsByUser[j] && safeDocsByUser[j].idDocumentation &&
                               typeof safeDocsByUser[j].idDocumentation === 'object' &&
                               safeDocsByUser[j].idDocumentation.id != null) {
                                if (safeDocsByUser[j].idDocumentation.id === requiredDocId) {
                                    found = true
                                    const doc = {
                                        id: safeDocsByUser[j].id,
                                        idDocumentation: safeDocsByUser[j].idDocumentation,
                                        name: safeDocsByUser[j].idDocumentation.name,
                                        file: safeDocsByUser[j].file,
                                        is_valid: safeDocsByUser[j].is_valid,
                                        is_company_document: safeDocsByUser[j].idDocumentation.is_company_document,
                                        uploaded_at: safeDocsByUser[j].uploaded_at,
                                        ocr_confidence: safeDocsByUser[j].ocr_confidence,
                                        extracted_data: safeDocsByUser[j].extracted_data,
                                        valid_until: safeDocsByUser[j].valid_until
                                    }
                                    processedDocumentations.push(doc)
                                    break
                                }
                            }
                        }
                        if(!found) {
                            let docName = 'Documento sin nombre'
                            if (validInvDocs[i].idDocumentation && typeof validInvDocs[i].idDocumentation === 'object') {
                                docName = validInvDocs[i].idDocumentation.name || validInvDocs[i].name || 'Documento sin nombre'
                            } else if (validInvDocs[i].name) {
                                docName = validInvDocs[i].name
                            }
                            let isCompanyDoc = false
                            if (validInvDocs[i].idDocumentation && typeof validInvDocs[i].idDocumentation === 'object') {
                                isCompanyDoc = validInvDocs[i].idDocumentation.is_company_document || false
                            } else if (validInvDocs[i].is_company_document !== undefined) {
                                isCompanyDoc = validInvDocs[i].is_company_document
                            }
                            const missingDoc = {
                                id: null,
                                idDocumentation: { id: requiredDocId, name: docName },
                                name: docName,
                                file: null,
                                is_valid: false,
                                is_company_document: isCompanyDoc,
                                uploaded_at: null,
                                ocr_confidence: null,
                                extracted_data: null,
                                valid_until: null
                            }
                            processedDocumentations.push(missingDoc)
                        }
                    }
                }
                return processedDocumentations
            },
            activateDeleteGuest (token) {
                if (this.confirm === null) {
                    this.dialogConfirm = true
                    return
                }
                if (this.confirm === 'true') {
                    this.loading = true
                    const config = {
                        method: 'patch',
                        url: 'https://empresa-service.intrare.app/activateUser/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: { usrToken: token }
                    }
                    axios(config)
                        .then(() => {
                            this.loading = false
                            this.get_invitados_no_confirmados()
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_message', this.$t('msg_user_validated'))
                            this.dialogInfoGuest = false
                            setTimeout(this.clear, 3000)
                        })
                        .catch(error => {
                            this.loading = false
                            console.log(error)
                        })
                } else if (this.confirm === 'false') {
                    this.dialog_seguro = true
                }
            },
            eliminar_invitado () {
                const config = {
                    method: 'POST',
                    url: 'https://empresa-service.intrare.app/NoActivateUser/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        token: this.userInfo.temporalToken,
                        cellNumber: this.userInfo.celular
                    }
                }
                axios(config)
                    .then(() => {
                        this.dialog_seguro = false
                        this.get_invitados_no_confirmados()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_user_invalidated'))
                        this.dialogInfoGuest = false
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            openResendDialog (user) {
                this.resendTargetUser = user
                this.dialogResendEmail = true
            },
            resendPreregistrationEmail () {
                if (!this.resendTargetUser)return
                this.loadingResend = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/Provider/ResendPreregistrationEmail/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: { userId: this.resendTargetUser.id }
                }
                axios(config)
                    .then(() => {
                        this.loadingResend = false
                        this.dialogResendEmail = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Correo de pre-registro reenviado exitosamente')
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loadingResend = false
                        const status = error.response ? error.response.status : null
                        const msg = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : 'Error al reenviar el correo'
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', status === 429 ? 'warning' : 'error')
                        this.$store.commit('snackbar_change_message', msg)
                        setTimeout(this.clear, 4000)
                        if (status !== 429) {
                            this.dialogResendEmail = false
                        }
                    })
            },
            clear () {
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            isOcrSupported (doc) {
                if (!doc||!doc.idDocumentation||!doc.idDocumentation.name) return false
                const name = doc.idDocumentation.name.toUpperCase()
                if (name.includes('INE') || name.includes('LICENCIA')) return false
                if (doc.ocr_confidence === null && (!doc.extracted_data||doc.extracted_data==='{}')) return false
                return true
            },
            formatKey (key) {
                if (!key)return''
                if (this.$te(key)) return this.$t(key)
                return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
            },
            formatValue (value) {
                if (value === true || value === 'true' || value === 'True') return 'Correcto'
                if (value === false || value === 'false' || value === 'False') return 'Incorrecto'
                return value
            },
            formatDate (dateString) {
                if (!dateString)return''
                return new Date(dateString).toLocaleDateString()
            },
            hasExtractedData (data) {
                const parsed = this.parseExtractedData(data)
                return parsed && Object.keys(parsed).length > 0
            },
            parseExtractedData (data) {
                if (!data)return{}
                if (typeof data === 'object') return data
                let jsonStr = data
                if (typeof data === 'string' && data.includes("'")) {
                    jsonStr = data
                        .replace(/'/g, '"')
                        .replace(/\bTrue\b/g, 'true')
                        .replace(/\bFalse\b/g, 'false')
                        .replace(/\bNone\b/g, 'null')
                }
                try {
                    return JSON.parse(jsonStr)
                } catch (e) {
                    console.warn('Error parsing extracted_data:', e)
                    return {}
                }
            }
        }
    }
</script>

<style scoped>
    .display-title {
        display: flex;
        align-items: center;
    }
</style>
